export enum CreateUserResult {
  Error,
  Success,
  DataIssue,
  Duplicate,
  PasswordStrength
}
